import React from "react";
import { Row, Col, Form, Modal, Divider} from "antd";
import {getCountryList, getBankCode, checkingDuplicationBankInfo} from "../../api/api";
import {displayError, displayGenericError} from "../../common/notifications";
import BeneficiaryInformationTab from "./BeneficiaryInformationTab";
import BankAccountInformationTab from "./BankAccountInformationTab";
import BrdgxCountrySelector from "../selector/BrdgxCountrySelector";
import BeneficiaryTypeTab from "./BeneficiaryTypeTab";
import {
    COUNTRY_AUSTRIA,
    COUNTRY_CANADA,
    COUNTRY_DENMARK,
    COUNTRY_FRANCE,
    COUNTRY_GERMANY,
    COUNTRY_ITALY,
    COUNTRY_PORTUGAL,
    COUNTRY_SPAIN,
    COUNTRY_SWEDEN,
    COUNTRY_SWITZERLAND,
    COUNTRY_UAE,
    COUNTRY_UK,
    COUNTRY_US,
    COUNTRY_AUSTRALIA, COUNTRY_CHINA,
    COUNTRY_HONG_KONG,
    COUNTRY_INDONESIA,
    COUNTRY_MALAYSIA, COUNTRY_PHILIPPINES,
    COUNTRY_SINGAPORE, COUNTRY_THAILAND, COUNTRY_VIETNAM, NETHERLANDS
} from "../../domain/CountryCode";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
const confirm = Modal.confirm;
class BeneficiaryModal extends React.Component {

  state = {
    beneficiaryType: 'INDIVIDUAL',
    countries: [],
    bankCountry: '',
    banks: [],
    beneficiaryInformation: {},
    bankAccountInformation: {
        newBank:false
    },
    bankName: '',
    bankCountryCode:'',
    bankCode: '',
    bankCodeCode: '',
    isPaymentGlobal:false
  };

    constructor(props) {
        super(props);
    }


    onBeneficiaryTypeSelected = newBeneficiaryType => {
    this.setState({
      beneficiaryType: newBeneficiaryType
    });
  };

  onBeneficiaryInformationCompleted = beneficiaryInformation => {
    let selectedBeneficiary = this.state.selectedBeneficiary;
    if(selectedBeneficiary) {
        selectedBeneficiary.beneficiaryInformation = beneficiaryInformation;
        this.setState({
            selectedBeneficiary: selectedBeneficiary
        });
    } else {
        this.setState({
            beneficiaryInformation: beneficiaryInformation
        });
    }


  };

  onBankAccountInformationCompleted = bankAccountInformation => {
      let selectedBeneficiary = this.state.selectedBeneficiary;
      if(selectedBeneficiary) {
          selectedBeneficiary.bankAccountInformation = bankAccountInformation;
          this.setState({
              selectedBeneficiary: selectedBeneficiary
          });
      } else {
          this.setState({
              bankAccountInformation: bankAccountInformation
          })
      }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.visible == false && prevProps.visible == true) {
          this.setState({
              selectedBeneficiary: null
          })
      }
      if (this.props.visible == true && prevProps.visible == false) {
          if(this.props.selectedBeneficiary) {
              getBankCode(this.props.selectedBeneficiary.bankCountry)
                  .then(response => {
                      this.setState({
                          banks: response,
                          isPaymentGlobal: true
                      })
                  }).catch(error => {
                  displayGenericError(error);
              });
          } else {
              this.setState({
                  banks: [],
                  bankCodeCode: '',
                  bankCountry: '',
                  bankCode: '',
                  beneficiaryInformation: {},
                  bankAccountInformation: {}
              })
          }
      }
  }

    componentDidMount() {
    
    getCountryList()
      .then(response => {
        this.setState({
            countries: response
        });
      })
      .catch(error => {
          displayGenericError(error);
      });
    
    if(this.state.bankCountry){
      getBankCode(this.state.bankCountry)
        .then(response => {
            this.setState({
                banks: response
            })
        }).catch(error => {
          displayGenericError(error);
        });
    }

  }

  onBankCountryChange = bankCountry => {
    getBankCode(bankCountry)
      .then(response => {
          const intl = this.props.useIntl;
          let isPaymentGlobal = this.checkPaymentGlobal(bankCountry);
          let selectedBeneficiary = this.props.selectedBeneficiary;
          let countryCodeIso2 = (response != null && response.length > 0) ? response[0].country : '';
          if (selectedBeneficiary) {
              selectedBeneficiary.bankCountry = bankCountry;
              selectedBeneficiary.bankCountryCode = countryCodeIso2;
              selectedBeneficiary.bankCodeCode = '';
              if (!(selectedBeneficiary.id > 0)) {
                  selectedBeneficiary.accountNumber='';
              }
              selectedBeneficiary.bankCode='';
              if (bankCountry === 'C048') {
                  displayError(intl.formatMessage({id: "app.message.beneficiarymodal.cannotchangebankcountry"}))
                  return;
              }
              this.setState({
                  selectedBeneficiary: selectedBeneficiary,
                  banks: response,
                  // bankCountryCode: (response != null && response.length > 0) ? response[0].country : '',
                  bankName: '',
                  bankCode: '',
                  bankCodeCode: '',
                  isPaymentGlobal: isPaymentGlobal
              })
              this.changeSelectedBeneficiary(selectedBeneficiary);
          }  else {

              this.setState({
                  bankCountry: bankCountry,
                  banks: response,
                  bankCountryCode: countryCodeIso2,
                  bankName: '',
                  bankCode: '',
                  bankCodeCode: '',
                  isPaymentGlobal: isPaymentGlobal
              })
          }


      }).catch(error => {
        displayGenericError(error);
      });
  }

  updateBank = (bankName, bankCode, bankCodeCode, newBank=false, accountNumber) =>{
      let bankAccountInformation = this.state.bankAccountInformation;
      let selectedBeneficiary = this.props.selectedBeneficiary;
      if(selectedBeneficiary) {
          selectedBeneficiary.bankName = bankName;
          selectedBeneficiary.bankCode = bankCode;
          selectedBeneficiary.newBank=newBank;
          selectedBeneficiary.bankCodeCode = bankCodeCode;
          this.setState({ selectedBeneficiary: selectedBeneficiary})
      }  else {
          if (newBank) {
              bankAccountInformation.bankName = bankName;
              bankAccountInformation.bankCode = bankCode;
              bankAccountInformation.bankCodeCode = bankCodeCode;
              bankAccountInformation.newBank = newBank;
          }
          if(accountNumber) {
            bankAccountInformation.accountNumber = accountNumber;
              bankAccountInformation.bankName = bankName;
              bankAccountInformation.bankCode = bankCode;
              bankAccountInformation.bankCodeCode = bankCodeCode;
          }
          this.setState({
              bankName: bankName,
              bankCode: bankCode,
              newBank: newBank,
              bankCodeCode: bankCodeCode,
              bankAccountInformation: bankAccountInformation
          })
      }

  }

  checkPaymentGlobal (bankCountry){
    let result = true;

    // C022: AUSTRIA,C060: DENMARK, C068: FRANCE, C074: GERMANY
    // C093: ITALY, C153: PORTUGAL, C181: SPAIN, C185: SWEDEN, C044: CANADA, C198: UNITED ARAB EMIRATES
    // C186: SWITZERLAND
    // C004: United Kingdom
    // result =  (
    //     bankCountry === COUNTRY_AUSTRIA
    //     || bankCountry === COUNTRY_UK
    //     || bankCountry === COUNTRY_US
    //     || bankCountry === COUNTRY_CANADA
    //     || bankCountry === COUNTRY_DENMARK
    //     || bankCountry === COUNTRY_FRANCE
    //     || bankCountry === COUNTRY_GERMANY
    //     || bankCountry === COUNTRY_ITALY
    //     || bankCountry === COUNTRY_PORTUGAL
    //     || bankCountry === COUNTRY_SPAIN
    //     || bankCountry === COUNTRY_SWEDEN
    //     || bankCountry === COUNTRY_UAE
    //     || bankCountry === COUNTRY_SWITZERLAND
    // );
    return result;
  }

    onOk = async () => {
        const intl = this.props.useIntl;
        let selectedBeneficiary = this.props.selectedBeneficiary;
        let title = intl.formatMessage({id: "app.common.save.data"});

        if(selectedBeneficiary) {

            let industryVal = this.props.selectedBeneficiary.industry;
            if(industryVal){
                let item = this.props.industries.filter(s => s.value === industryVal);
                if(item){
                    this.props.selectedBeneficiary.industry = item[0].code;
                }
            }


            let originators = this.props.selectedBeneficiary.originators;
            if(originators) {
                if (originators.length > 0) {
                    let originatorIds = [];
                    originators.forEach(item=>{
                        originatorIds.push(item.id);
                    })
                    selectedBeneficiary.originatorIds = originatorIds;
                }
            }

            if (selectedBeneficiary.newBank == true) {
                if (selectedBeneficiary.bankCode.length < 8 || selectedBeneficiary.bankCode.length > 11) {
                    displayGenericError({message: intl.formatMessage({id: "app.message.beneficiarymodal.swiftlength"})});
                    return;
                }
            }
            try {
                let res = await checkingDuplicationBankInfo(this.props.currentCustomer.id, selectedBeneficiary);
                if (res.result) {
                    title = intl.formatMessage({id: "app.modal.beneficiarymodal.bank.duplicate"}) + " " + res.result + ". " + title;
                }
            } catch (e) {
                displayError(JSON.stringify(e));
                return;
            }
            confirm({
                title: <p>{title}</p>,
                onOk: () => {
                    this.props.onCompleted(selectedBeneficiary);
                }});

        } else {
            if (!this.state.bankAccountInformation.accountNumber) {
                displayError(intl.formatMessage({id: "app.message.beneficiarymodal.accountnumber"}));
                return;
            }

            if (this.state.isPaymentGlobal) {
                if (this.state.bankAccountInformation && this.state.bankAccountInformation.newBank == true) {
                    if (this.state.bankCode.length < 8 || this.state.bankCode.length > 11) {
                        displayGenericError({message: intl.formatMessage({id: "app.message.beneficiarymodal.swiftlength"})});
                        return;
                    }
                }
            }
            if (this.props.checkAddress && !this.state.beneficiaryInformation.addressLine1 && !this.state.beneficiaryInformation.addressLine2) {
                displayError(intl.formatMessage({id: "app.message.beneficiarymodal.address"}));
                return;
            }
            if (!this.state.bankAccountInformation.clearingCode) {
                if (this.state.bankCountry === 'C020') {
                    displayError(intl.formatMessage({id: "app.message.beneficiarymodal.clearingcode"}));
                    return;
                } else if (this.state.bankCountry === 'C004') {
                    displayError(intl.formatMessage({id: "app.message.beneficiarymodal.sortcode"}));
                    return;
                } else if (this.state.bankCountry === 'C005') {
                    displayError(intl.formatMessage({id: "app.message.beneficiarymodal.routingnumber"}));
                    return;
                }
            }

            if (!this.state.beneficiaryInformation.addressLine1) {
                displayError(intl.formatMessage({id: "app.message.beneficiarymodal.beneficiaryaddress"}));
                return;
            }
            if (this.state.beneficiaryType == "CORPORATE") {
                if (!this.state.beneficiaryInformation.industry) {
                    displayError(intl.formatMessage({id: "app.message.beneficiarymodal.businessnature"}));
                    return;
                }
            }

            /*if(!this.state.bankAccountInformation.accountCurrency) {
                displayError(intl.formatMessage({id: "app.message.bankaccountinformationtab.accountcurrency"}));
                return;
            }*/
            if(!this.state.bankAccountInformation.transferCurrencies || this.state.bankAccountInformation.transferCurrencies.length==0) {
                displayError(intl.formatMessage({id: "app.message.bankaccountinformationtab.transfer.currency"}));
                return;
            }

            let industryVal = this.state.beneficiaryInformation.industry;
            if(industryVal){
                let item = this.props.industries.filter(s => s.value === industryVal);
                if(item){
                    this.state.beneficiaryInformation.industry = item[0].code;
                }
            }

            let beneficiary = {
                firstName: this.state.beneficiaryInformation.firstName,
                lastName: this.state.beneficiaryInformation.lastName,
                businessName: this.state.beneficiaryInformation.businessName,
                email: this.state.beneficiaryInformation.email === '' ? null : this.state.beneficiaryInformation.email,
                addressLine1: this.state.beneficiaryInformation.addressLine1,
                addressLine2: this.state.beneficiaryInformation.addressLine2,
                accountCurrency: this.state.bankAccountInformation.accountCurrency,
                transferCurrencies: this.state.bankAccountInformation.transferCurrencies,
                relationship: this.state.beneficiaryInformation.relationship,
                accountNumber: this.state.bankAccountInformation.accountNumber,
                bankCountry: this.state.bankCountry,
                bankCountryCode: this.state.bankCountryCode,
                bankName: this.state.bankAccountInformation.bankName,
                bankCode: this.state.bankAccountInformation.bankCode,
                newBank: this.state.bankAccountInformation.newBank,
                clearingCode: this.state.bankAccountInformation.clearingCode,
                idNumber: this.state.beneficiaryInformation.idNumber,
                bankBranchName: this.state.bankAccountInformation.bankBranchName,
                beneficiaryType: this.state.beneficiaryType,
                postalCode: this.state.beneficiaryInformation.postalCode,
                businessNumber: this.state.beneficiaryInformation.businessNumber,
                beneficiaryCountry: this.state.beneficiaryInformation.country,
                bankCodeCode: this.state.bankAccountInformation.bankCodeCode,
                nationality: this.state.beneficiaryInformation.nationality,
                industry: this.state.beneficiaryInformation.industry,
                remark: this.state.beneficiaryInformation.remark,
                bankAccountName: this.state.bankAccountInformation.bankAccountName,
                dob: this.state.beneficiaryInformation.dob,
                contactNumber: this.state.beneficiaryInformation.contactNumber,
                idType: this.state.beneficiaryInformation.idType,
                gender: this.state.beneficiaryInformation.gender,
                businessRegistrationDate: this.state.beneficiaryInformation.businessRegistrationDate,
                aliasName: this.state.beneficiaryInformation.aliasName,
                formerName:this.state.beneficiaryInformation.formerName
            };
            let originators = this.state.beneficiaryInformation.selectedOriginators;
            let originatorIds = [];
            if(originators) {
                if (originators.length > 0) {
                    originators.forEach(item=>{
                        originatorIds.push(item.id);
                    })
                    beneficiary.originatorIds = originatorIds;
                }
            }

            try {
                let res = await checkingDuplicationBankInfo(this.props.currentCustomer.id, beneficiary);
                if (res.result) {
                    title = intl.formatMessage({id: "app.modal.beneficiarymodal.bank.duplicate"}) + " " + res.result + ". " + title;
                }
            } catch (e) {
                displayError(JSON.stringify(e));
                return;
            }
            confirm({
                title: <p>{title}</p>,
                onOk: () => {
                    this.props.onCompleted(beneficiary);
                }});
        }
    }

  changeSwiftCode = (ev) => {
      let selectedBeneficiary = this.props.selectedBeneficiary;
      if(selectedBeneficiary) {
          selectedBeneficiary.bankCode = ev.target.value;
          this.changeSelectedBeneficiary(selectedBeneficiary)
          // this.props.changeSelectedBeneficiary(selectedBeneficiary)
      }else {
          let bankAccountInformation = this.state.bankAccountInformation;
          bankAccountInformation.bankCode = ev.target.value;
          this.setState({
              bankCode: ev.target.value,
              bankAccountInformation: bankAccountInformation
          })
      }
    // this.props.onCompleted(beneficiary);
  }

    addNewBankName = (newBankName) => {
        const intl = this.props.useIntl;
        let banks = [...this.state.banks];
        let sameNameBank = banks.filter(item => item.value ===newBankName);
        if(sameNameBank.length>0){
            displayError(intl.formatMessage({id: "app.message.beneficiarymodal.banknamealreadyexists"}));
            return;
        }

        let country = this.state.bankCountry;

        banks.push({
            country: country,
            value: newBankName,
            code:newBankName,
            swift: '',
            newBank: true,
            bankCodeCode: newBankName
        })
        this.setState({
            banks:banks,
        })
        this.updateBank(newBankName,'',newBankName, true);
    }

    changeSelectedBeneficiary = beneficiary => {
      this.props.changeSelectedBeneficiary(beneficiary);
    }

  render() {
    const intl = this.props.useIntl;
    let selectedBeneficiary = this.props.selectedBeneficiary;
    return (
      <Modal
        className="bp-modal"
        title={selectedBeneficiary ? intl.formatMessage({id: "app.modal.beneficiarymodal.editbeneficiary"},{referenceNumber: selectedBeneficiary.referenceNumber})
                                    : intl.formatMessage({id: "app.modal.beneficiarymodal.addnewbeneficiary"})}
        visible={this.props.visible}
        onOk={this.onOk}
        onCancel={this.props.onCancel}
        maskClosable={false}
        destroyOnClose={true}
        width="1024px"
        style={{top: "50px"}}
      >
        <Row gutter={16}>
          <Col md={6}>
              <Form.Item label={intl.formatMessage({id: "app.modal.beneficiarymodal.beneficiarytype"})}>
                <BeneficiaryTypeTab
                  selectedBeneficiary={selectedBeneficiary}
                  onCancel={this.props.onCancel}
                  onBeneficiaryTypeSelected={newBeneficiaryType => this.onBeneficiaryTypeSelected(newBeneficiaryType)}
                  value={selectedBeneficiary ? selectedBeneficiary.beneficiaryType : this.state.beneficiaryType}
                  corpAllow="true"
                />
              </Form.Item>
          </Col>

          <Col md={12}>
            <Form.Item
                required="true"
                hasFeedback
               // validateStatus={this.state.country.validateStatus}
               // help={this.state.country.errorMsg}
                label={intl.formatMessage({id: "app.modal.beneficiarymodal.bankcountry"})}
            >
              <BrdgxCountrySelector
                  placeholder={intl.formatMessage({id: "app.modal.beneficiarymodal.selectcountry"})}
                  style={{width: '100%'}}
                  size={"large"}
                  name="country"
                  countries={this.state.countries}
                  value={selectedBeneficiary ? selectedBeneficiary.bankCountry : this.state.bankCountry}
                  onChange={country =>
                    this.onBankCountryChange(country)
                  }

              />
            </Form.Item>
          </Col>
        </Row>

        <BeneficiaryInformationTab
          beneficiaryType={selectedBeneficiary ? selectedBeneficiary.beneficiaryType : this.state.beneficiaryType}
          selectedOriginator={this.props.selectedOriginator}
          currentCustomer={this.props.currentCustomer}
          bankCountry={selectedBeneficiary ? selectedBeneficiary.bankCountry : this.state.bankCountry}
          industries={this.props.industries}
          selectedBeneficiary={selectedBeneficiary}
          changeSelectedBeneficiary = {(beneficiary) => this.changeSelectedBeneficiary(beneficiary)}
          style={{width: 330}}
          onCompleted={beneficiaryInformation =>
            this.onBeneficiaryInformationCompleted(beneficiaryInformation)
          }
        />
        <Divider />
        <BankAccountInformationTab
            currentCustomer={this.props.currentCustomer}
            currency={this.props.currency}
            bankCountry={selectedBeneficiary ? selectedBeneficiary.bankCountry : this.state.bankCountry}
            banks={this.state.banks}
            bankName={this.state.bankName}
            selectedBeneficiary={selectedBeneficiary}
            changeSelectedBeneficiary={this.changeSelectedBeneficiary}
            newBank={this.state.newBank}
            bankCode={this.state.bankCode}
            addNewBankName={this.addNewBankName}
            bankCodeCode={this.state.bankCodeCode}
            isPaymentGlobal={this.state.isPaymentGlobal}
            onChangeSwiftCode={this.changeSwiftCode}
            updateBank={(bankName, bankCode, bankCodeCode, newBank, accountNumber) =>
              this.updateBank(bankName, bankCode, bankCodeCode,newBank, accountNumber)}
            onCompleted={bankAccountInformation =>
              this.onBankAccountInformationCompleted(bankAccountInformation)
            }
        />
      </Modal>
    );
  }
}

export default withUseIntl(BeneficiaryModal);